<div class="icon">
	<img [src]="iconImage" [attr.alt]="title ? title.toLowerCase() : ''" />
</div>
<div class="description">
	<div *ngIf="title" class="title" [innerHtml]="title"></div>
	<div *ngIf="titleNote" class="title-note" [innerHtml]="titleNote"></div>
	<div
		*ngIf="marketing"
		class="marketing-text"
		[ngClass]="marketing.textDecoration"
		[innerHtml]="marketing.text"
	></div>
	<div class="price-line">
		<span *ngIf="subtitle" class="price-text">{{
			subtitle
		}}</span>
		<span *ngIf="price && promoDiscountValue" class="price-before-discount"
			>${{ price }}</span
		>
		<span *ngIf="price && !promoDiscountValue" class="price"
			>${{ price }}</span
		>
		<span *ngIf="promoDiscountValue" class="price"
			>${{ price - promoDiscountValue }}</span
		>
		<span *ngIf="afterPriceText" class="price-text">{{
			afterPriceText
		}}</span>
	</div>
	<div class="price-line">
		<span *ngIf="promoDiscountDuration" class="discount-duration">{{
			promoDiscountDuration
		}}</span>
	</div>
	<div class="price-line">
		<span *ngIf="promoDiscountValue && promoEndDate" class="discount-duration">
			Offers ends {{promoEndDate | ordinalDateTime}}.
		</span>
	</div>
</div>
<div class="toggle-icon">
	<!-- <div class="blank">
		<img src="assets/img/icons/blank.svg" alt="blank" />
	</div>
	<div class="radio">
		<img src="assets/img/icons/radio.svg" alt="radio" />
	</div> -->
</div>
